import React, { useState } from 'react'
import { useDebounce } from 'use-debounce'
import { UserDocument } from '@rallycry/api-suite-typescript'
import { isArray } from 'lodash-es'
import { useRcTranslation } from '@/core/hooks/useRcTranslation'
import { useUserDocument } from '@/entity/user/useUserDocument'
import { EntityAutocomplete } from '@/components/molecules/input/EntityAutocomplete'

export const RcUserSearch = ({
  selected,
  setSelected
}: {
  selected?: UserDocument | null
  setSelected: (user?: UserDocument | null) => void
}) => {
  const { t } = useRcTranslation()
  const [query, setQuery] = useState<string>('')
  const [debouncedQuery] = useDebounce(query, 300)
  const {
    users,
    query: { isValidating, size, setSize }
  } = useUserDocument({
    request: {
      q: debouncedQuery
    }
  })

  return (
    <EntityAutocomplete
      isValidating={isValidating}
      options={users}
      selected={selected ? [selected] : []}
      placeholder={t('user-search-placeholder')}
      onSearch={q => setQuery(q)}
      onLoadOptions={() => setSize(size + 1)}
      onChange={async updated => {
        const user = isArray(updated) ? undefined : updated
        setSelected(user)
      }}
    />
  )
}
